/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, amount: NonNullable<unknown> }} Error_Shop_Tier_Min_Spend_DuplicateInputs */

const vi_error_shop_tier_min_spend_duplicate = /** @type {(inputs: Error_Shop_Tier_Min_Spend_DuplicateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mốc trùng với hạng ${i?.name} (${i?.amount}).`)
};

/**

* @param {Error_Shop_Tier_Min_Spend_DuplicateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_tier_min_spend_duplicate = /** @type {((inputs: Error_Shop_Tier_Min_Spend_DuplicateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Tier_Min_Spend_DuplicateInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_tier_min_spend_duplicate(inputs)
});